import { Box, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import "../View/SuiteHistory.css";
import { returnAppIcon } from "../View/SuiteHistoryView";

interface ReviewSuggestionsAppsProps {
  suggestionApps: string[];
  activeApp: any;
}

export const ReviewSuggestionsApps = ({
  suggestionApps,
  activeApp,
}: ReviewSuggestionsAppsProps) => {
  const navigate = useNavigate();

  const handleNavigateToSuggestionApp = (app: string) => {
    navigate("/suites/image-suite", {
      state: { imageSuiteAppName: app, imageSuiteAppData: activeApp },
    });
  };

  return (
    <Box className="review-suggestions-apps">
      <Box className="review-suggestions-apps-heder">
        <Typography className="suggestions-apps-heder-title">
        Quick Edits
        </Typography>
      </Box>
      <Box
        className="review-suggestions-apps-suggestions"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: { xs: "flex-start", lg: "unset" },
        }}
      >
        {suggestionApps.map((app, i) => (
          <>
            <Box
              key={i}
              className="suggestion-app"
              onClick={() => handleNavigateToSuggestionApp(app)}
              sx={{
                width: { xs: "100%", lg: "175px" },
              }}
            >
              <Box className="suggestion-app-icon">{returnAppIcon(app)}</Box>
              <Box className="suggestion-app-name">{app}</Box>
            </Box>
          </>
        ))}
      </Box>
    </Box>
  );
};
